import type { Document } from "@contentful/rich-text-types";

import { createUseQueryEntry } from "./client";

export interface ContentfulWelcomeCallToActionFields {
	title: Document;
}
export const CONTENTFUL_ENTRY_WELCOME_CALL_TO_ACTION = "7EhKV3W9EFg2xsIxmF1yaT";
export const useQueryWelcomeCallToAction = createUseQueryEntry<ContentfulWelcomeCallToActionFields>(
	CONTENTFUL_ENTRY_WELCOME_CALL_TO_ACTION,
);
